export const CUSTOMER_MANAGEMENT_GET_SELECTED = 'CUSTOMER_MANAGEMENT_GET_SELECTED';
